import * as React from 'react';
import type { SVGProps } from 'react';
const SvgClose = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.782 5.778c3.704-3.704 9.732-3.704 13.436 0 3.703 3.704 3.703 9.73 0 13.434A9.47 9.47 0 0 1 12.5 21.99a9.47 9.47 0 0 1-6.718-2.778A9.438 9.438 0 0 1 3 12.495a9.44 9.44 0 0 1 2.782-6.717Zm-1.31 6.717a7.98 7.98 0 0 0 2.35 5.677c3.131 3.13 8.225 3.13 11.355 0 3.13-3.13 3.13-8.224 0-11.354-3.13-3.13-8.224-3.13-11.354 0a7.979 7.979 0 0 0-2.351 5.677Zm9.115-.046 2.084 2.08a.736.736 0 1 1-1.04 1.041l-2.085-2.081-2.085 2.081a.736.736 0 0 1-1.04-1.04l2.083-2.081-2.084-2.08a.736.736 0 1 1 1.04-1.042l2.085 2.082 2.085-2.082a.736.736 0 1 1 1.04 1.042l-2.083 2.08Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgClose;
